import imgNotFound from '@/assets/pageNotFound.png';
import { ApplicationState } from '@/store';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import './style.scss';

const PageNotFound: React.FC = () => {
    const { data: strings } = useSelector((state: ApplicationState) => state.locale);

    const location = useLocation();
    const history = useHistory();

    useEffect(() => {
        if (['http://localhost:3000/#/', 'https://dev.afferolab.net:3000/#/'].indexOf(window.location.href) !== -1) {
            window.location.href = window.location.href.split('/#/').join('/cast/afferolab/#/');
        }
    }, [location, history]);

    const goToHomePage = () => {
        history.push('/');
    };

    return (
        <div className="page-not-found">
            <div className="page-not-found__content">
                <img src={imgNotFound} />
                <span className="page-not-found__title">{strings.PAGE_UNAVAILABLE}</span>
                <span className="page-not-found__subtitle">{strings.TEXT_PAGE_UNAVAILABLE}</span>
                <button className="page-not-found__home-redirect-button" onClick={() => goToHomePage()} type="button">
                    {strings.GO_TO_HOME_PAGE}
                </button>
            </div>
        </div>
    );
};

export default PageNotFound;
